import classNames from 'classnames';
import EcoButtonThree from 'eco-design/base/eco-button-three';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React, { useState } from 'react';
import { EcoGraphicSwiperItemProps } from './props';

const EcoGraphicSwiperItem: React.FC<EcoGraphicSwiperItemProps> = (item) => {
    const prefixCls = `eco-graphic-swiper-item`;
    const classes = classNames(prefixCls, {});
    const itemStyle = {
        '--graphic-item-labelColor': item.labelColor,
        '--graphic-item-titleColor': item.titleColor,
        '--graphic-item-descColor': item.descColor,
    } as React.CSSProperties;

    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className={classes} style={itemStyle}>
            <div className={`${prefixCls}-img`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                <div className="image-container" style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            opacity: isHovered && item.pcHover ? 0 : 1,
                            transition: 'opacity 0.5s ease',
                        }}
                    >
                        <EcoImgVideo {...item} isVideo={item.isVideo} pc={item.pc} />
                    </div>
                    {item.pcHover && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                opacity: isHovered ? 1 : 0,
                                transition: 'opacity 0.5s ease',
                            }}
                        >
                            <EcoImgVideo {...item} isVideo={item.isVideo} pc={item.pcHover} />
                        </div>
                    )}
                </div>
            </div>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-label`}>{item.label}</div>
                <div className={`${prefixCls}-title`}>{item.title}</div>
                <div className={`${prefixCls}-desc`}>{item.desc}</div>
                <EcoButtonThree {...item} className={`${prefixCls}-btns`} />
            </div>
        </div>
    );
};

export default EcoGraphicSwiperItem;
